import { render, staticRenderFns } from "./CompetenceCategoryIcon.vue?vue&type=template&id=1fc6c74a"
import script from "./CompetenceCategoryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetenceCategoryIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports